import { Home } from "./components/Home";

const AppRoutes = [
    {
        index: true,
        element: <Home />,
        path: '/:propertyId?/:clientId?/:officeId?/:contactId?/:languageId?/:iframe?',
    },
    {
        element: <Home />,
        path: "/:propertyId?/:clientId?/:officeId?/:languageId?/:iframe?",
    },
    {
        element: <Home />,
        path: "/:propertyId?/:languageId?/:iframe?",
    },
];

export default AppRoutes;
